import { useQuinceRouter as useRouter } from '@src/modules/navigation'
import { useCallback, useRef, useState } from 'react'

import useLoginUser from '../../../../hooks/useLoginUser'

import { InitialPage } from './Views/InitialPage'
import { SecondaryPage } from './Views/SecondaryPage'
import { getSanitizedRedirectUrls } from '../../../Auth/utils'
import { email } from '@src/quince-components/src/molecules/tradeApplicationForm/trade-application-form-json/constants'

interface LoginVariantAPropTypes {
  serverError?: { message: string }
  unverifiedAccount?: boolean
  resendVerificationEmail: (email?: string) => void
  verificationEmailSent?: boolean
  onGoogleLogIn: (user: any) => void
  email: string
  register: (x: string, y: object) => object
  errors: Record<string, { message: string }>
  backToLogin: () => void
  loading?: boolean
  page: any
  pageState: 'INITIAL' | 'SECONDARY'
  login: (data: object) => void
  openResetPasswordModal: (email: string) => void
  isInResetPasswordFlow?: boolean
}

const LoginVariantA = (props: LoginVariantAPropTypes) => {
  const router = useRouter()
  const email = useRef<string | undefined>()
  const [pageState, setPageState] = useState('INITIAL')
  const [pageLoading, setPageLoading] = useState(false)
  // TODO-SSR: Add useLoginUser function back after fixing the provider for auth
  const { loginUser } = useLoginUser()

  const onPageStateChange = (username: string) => {
    email.current = username
    setPageLoading(true)

    loginUser(username, '#').catch((error: unknown) => {
      const errorCode = error && (error as { code: string }).code

      if (errorCode === 'PasswordResetRequiredException') {
        props.openResetPasswordModal?.(username)
      }
      if (errorCode === 'UserNotFoundException') {
        const redirectUri = getSanitizedRedirectUrls()
        const navigateTo =
          redirectUri && redirectUri !== ''
            ? `/sign-up?redirecturi=${redirectUri}&userMail=${btoa(username)}`
            : `/sign-up/?userMail=${btoa(username)}`

        router.replace(navigateTo)
      } else if (error && (error as { code: string }).code === 'NotAuthorizedException') {
        setPageState('SECONDARY')
      }
      setPageLoading(false)
    })
  }

  const onEmailEdit = useCallback(() => {
    setPageState('INITIAL')
  }, [])

  return !props.isInResetPasswordFlow && pageState === 'INITIAL' ? (
    <InitialPage
      {...props}
      onPageStateChange={onPageStateChange}
      loading={pageLoading || props.loading}
      email={email.current}
    />
  ) : (
    <SecondaryPage
      {...props}
      email={email.current}
      loading={pageLoading || props.loading}
      onEmailEdit={onEmailEdit}
      isInResetPasswordFlow={props.isInResetPasswordFlow}
    />
  )
}

export { LoginVariantA }
